import { ADD_NEW_ACCOUNT, UPDATE_ACCOUNT, DELETE_ACCOUNT, FETCH_ACCOUNTS_BY_USER, START_LOADING, END_LOADING } from '../actions/constants'

const accounts = (state = { isLoading: true, accounts: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true }
    case END_LOADING:
      return { ...state, isLoading: false }
    case FETCH_ACCOUNTS_BY_USER:
      return { ...state, accounts: action.payload }
    case ADD_NEW_ACCOUNT:
      return { ...state, accounts: [...state.accounts, action.payload] }
    case UPDATE_ACCOUNT:
      return { ...state, accounts: state.accounts.map((a) => (a._id === action.payload._id ? action.payload : a)) }
    case DELETE_ACCOUNT:
      return { ...state, accounts: state.accounts.filter((a) => a._id !== action.payload) }
    default:
      return state
  }
}

export default accounts
